/**
 * 買取伝票明細 (AP_Order_Line) の金額計算と数量チェック。
 * 買取伝票 (order.component) と 買取(貿易) (bb.component) で共通に使う。
 *
 * 背景 (2026-10 調査):
 * - 数量変更後に金額が再計算されないまま保存された明細があった (金額 ≠ 単価×数量)。
 *   金額は入力不可の計算項目なので、合計計算のたびに全明細を単価×数量で計算し直す。
 * - 数量に小数を入力すると、金額は小数で計算される一方、数量は DB の整数項目
 *   (AP_Order_Line.quantity = INTEGER) で切り捨てて保存されていた。数量は整数のみ受け付ける。
 */

/** 数量として受け付ける値か (整数のみ。マイナスは返品で使うため許可)。 */
export function isValidQuantity(value: any): boolean {
    return typeof value === 'number' && Number.isInteger(value);
}

/**
 * 全明細の金額を 単価×数量 で計算し直し、合計を返す。
 * 単価・数量のどちらかが数値でない明細は金額を 0 とする。
 */
export function recalcLineAmounts(items: any[]): number {
    let total = 0;
    for (const item of items || []) {
        const price = typeof item.price === 'number' && isFinite(item.price) ? item.price : null;
        const quantity = typeof item.quantity === 'number' && isFinite(item.quantity) ? item.quantity : null;
        item.amount = price !== null && quantity !== null ? price * quantity : 0;
        total += item.amount;
    }
    return total;
}

/**
 * 数量が整数でない明細の行番号 (1 始まり) を返す。
 * 数量が空 (null / 未入力) の明細は従来どおり許可する (金額 0。2026 年の明細の約 1% が数量空)。
 */
export function invalidQuantityRows(items: any[]): number[] {
    const rows: number[] = [];
    (items || []).forEach((item, i) => {
        const q = item.quantity;
        const empty = q === null || q === undefined || (typeof q === 'string' && q.trim() === '');
        if (!empty && !isValidQuantity(q)) {
            rows.push(i + 1);
        }
    });
    return rows;
}
